import { ProjectRPCSession } from '#/services/session';
import { ManifestListRequest } from "./requests";
import {queryProjectClient} from "../../clients";

// eslint-disable-next-line import/prefer-default-export
export class ManifestListSession extends ProjectRPCSession {
  constructor(account,project) {
    super(account,project);    
    this.resetRequestData();
  }

  resetRequestData() {
    this.request = ManifestListRequest();
    this.manifests = [];
    this.loading = false; // a request is open over the wire
    this.errorMessage = undefined;
    this.loadedFirstPage = false;
    this.resetPageData();
  }

  resetPageData() {
    this.manifests.length = 0; // empty without setting to new array for any watchers

    this.loading = false; // a request is open over the wire
    this.loadedFirstPage = false; // have we loaded a page yet
    this.loadedLastPage = false; // have we loaded the last page yet

    this.pageCursor = 0; // current page
    this.pageSize = 15; // num items per page

    this.errorMessage = undefined;
  }

  async loadPage() {
    if (this.loading || this.loadedLastPage) {
      return false;
    }
    this.loading = true;
    // TODO: abstract the header try/catch handling in in parent class
    const headers = await this.headers();
    return new Promise((resolve, reject) => { 
      queryProjectClient.listManifests(this.request , headers, (errors, response) => {
        if (errors != null) {
          this.error = errors;
          return reject(errors);
        }
        this.loading = false;
        const r = response.toObject();
        this.manifests.push(...r.manifestsList);
        console.log(this.manifests)
        this.pageCursor = r.nextCursor;
        console.log('PAGE CURSOR', this.pageCursor);

        if (this.pageCursor === -1) {
          console.log('manifest fully loaded');
          this.loadedLastPage = true;
        }
        return resolve();
      });
    }).catch((error) => {
      this.errorMessage = error.message !== '' ? error.message : 'Whoops... Something went wrong.';
    }).finally(() => {
      if (!this.loadedFirstPage) {
        this.loadedFirstPage = true;
      }
      this.loading = false;
    });
  }
}
